// flow weak

import React, {
    PureComponent
  }                             from 'react';
  import PropTypes              from 'prop-types';
  import AnimatedView           from '../../../../components';
  import styles                 from './style'
  import {
    defaultOptions,
    checkStatus,
    parseJSON,
    getLocationOrigin
  }                     from '../../../../services/fetchTools';
  import { withRouter } from 'react-router';
  import moment from 'moment';
  import Dialog from 'material-ui/Dialog';
  import FlatButton from 'material-ui/FlatButton';
  import RaisedButton from 'material-ui/RaisedButton';
  import DatePicker from 'react-datepicker';
  import TimeField from 'react-simple-timefield';
  
  class AddBulkBooking extends PureComponent {
    static propTypes = {
      actions: PropTypes.shape({
        enterPage: PropTypes.func,
        leavePage: PropTypes.func,
      })
    };
  
    constructor(props) {
      super(props);
      this.state = {
        customer_search_list: [],
        details: {
            venue: '',
            starting_date:'',
            ending_date: '',
            slot_time: '',
            courts: [],
            amount: 0,
            cust_name: '',
            mobile_no: '',
            cust_mobile_no: '',
            customer_id: '',
            game_type: '',
            starting_time:'',
            ending_time:'',
            reason:3,
            discount_amount:0,
            advance_amount:0,
        },
        game_list:[],
        venue_list: [],
        court_list: [],
        checkedBoxes:[],
        dayscheckedBoxes:[],
        blocked_court_list:[],
        available_court_list:[],
        isChecked: false,
        dialog_open_cust: false,
        search: false,
        time:'',
        submit_pressed:false,
        dialog_open_court_list:false,
        show_booking_option:false,
        loading: false
      };
      this.handleVenueChange = this.handleVenueChange.bind(this);
      this.handleChange = this.handleChange.bind(this);
      this.handleFormSubmit = this.handleFormSubmit.bind(this);
      this.handleCustomerSubmit = this.handleCustomerSubmit.bind(this);
      this.searchCustomer = this.searchCustomer.bind(this);
      this.handleStartDate = this.handleStartDate.bind(this);
      this.handleEndDate = this.handleEndDate.bind(this);
      this.onStartTimeChange = this.onStartTimeChange.bind(this);
      this.onTimeChange = this.onTimeChange.bind(this);
      this.handleBooking = this.handleBooking.bind(this);
    }
  
    componentDidMount() {
        this.getVenueList();
    }

    getVenueList(){
        const url = `${getLocationOrigin()}/court/get_venues_for_court/`;
         const options = {...defaultOptions};
    
        return fetch(url, options)
           .then(checkStatus)
           .then(parseJSON)
           .then(data => {this.setState({ venue_list: data.results, game_list: data.results[0].games}), this.getCourtList(data.results[0].id,data.results[0].games[0].game_id)})
           .catch(error => error);
    }

    getCourtList(venue_id,game){
        var new_selected_one =  Object.assign({}, this.state.details);
        new_selected_one['venue'] = venue_id
        new_selected_one['game_type'] = game
        this.setState({details: new_selected_one});
        const url = `${getLocationOrigin()}/court/getCourt/?venue_id=${venue_id}&game=${game}`;
        const options = {...defaultOptions};
    
        return fetch(url, options)
           .then(checkStatus)
           .then(parseJSON)
           .then(data => this.setState({ court_list: data.results}))
           .catch(error => error);
    }

    searchCustomer() {
        {this.state.details.mobile_no?this.getSearchList(this.state.details.mobile_no):
          alert('Search cannot be blank')}
    }

    handleCustomerSubmit(){
        console.log('post');
          
        const url = `${getLocationOrigin()}/eagleeye/add_new_customer/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
        options['body'] = JSON.stringify({
                            'customer_name': this.state.details.cust_name,
                            'customer_mobile': this.state.details.mobile_no,
                          });
        console.log('Going to fetch');
        return fetch(url, options)
          .then(checkStatus)
          .then(parseJSON)
          .catch(error => {
            console.log(error);
            alert(error.message);
          })
          .then(data => {
            if(data.success){
              var cust = Object.assign([], this.state.details);
              cust.push({'id': data.customer.id, 'name': data.customer.name, 'mobile_no':data.customer.mobile_no});
              this.setState({customer_search_list: cust});
              alert(data.message);
              this.handleClose();
            } else {
              alert(data.message);
            }
           });
    }

    getSearchList(mobile_no) {
        const url = `${getLocationOrigin()}/eagleeye/search/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
        options['body'] = JSON.stringify({
                             'search': mobile_no
                           });
        return fetch(url, options)
           .then(checkStatus)
           .then(parseJSON)
           .then(data => this.setState({customer_search_list: data.results, search: true}))
           .catch(error => {
             console.log(error);
             alert(error.message);
           });
    }

    setSearch(name, customer_id, mobile_no){
        var new_selected_one =  Object.assign({}, this.state.details);
        new_selected_one['customer_id'] = customer_id
        new_selected_one['mobile_no'] = mobile_no
        new_selected_one['name'] = name
        this.setState({details: new_selected_one, search: false});
    }

    handleVenueChange(event){
        const selected_venue_id = event.target.value;
        this.state.game_list = this.state.venue_list.filter(venue => venue.id == selected_venue_id)[0].games
        const name = event.target.name;
        var new_selected_one =  Object.assign({}, this.state.details);
        new_selected_one[name] = event.target.value
        new_selected_one['game_type'] = this.state.game_list[0].game_id
        this.setState({details: new_selected_one});
        if(event.target.value != 'true'){
          this.getCourtList(event.target.value,this.state.game_list[0].game_id)
        }
      }

    handleChange(event) {
        const name = event.target.name;
        var new_value =  Object.assign({}, this.state.details);
        new_value[name] = event.target.value
        this.setState({details: new_value});
    }

    handleGameChange(event){
    const game = event.target.value;
    const name = event.target.name;
    var new_selected_one =  Object.assign({}, this.state.details);
    new_selected_one[name] = event.target.value
    console.log(new_selected_one)
    this.setState({details: new_selected_one});
    if(event.target.value != 'true'){
      this.getCourtList(this.state.details.venue,game)
    }
    console.log(this.state)
  }

    handleOpen = () => {
        this.setState({dialog_open_cust:true});
    };
    
    handleClose = () => {
    this.setState({dialog_open_cust:false, dialog_open_court_list:false});
    };

    onTimeChange = time => {
      var new_selected_one =  Object.assign({}, this.state.details);
      new_selected_one['ending_time'] = time
      this.setState({details:new_selected_one })
    }

    onStartTimeChange = time => 
    {
      var new_selected_one =  Object.assign({}, this.state.details);
      new_selected_one['starting_time'] = time
      this.setState({details:new_selected_one })
    }
    

    handleCheckbox = (e, s) => {
        const checkedBoxes = [...this.state.checkedBoxes];
        if(e.target.checked) {
            checkedBoxes.push(s)
        } else {
            const index = checkedBoxes.findIndex((ch) => ch.id === s.id);
            checkedBoxes.splice(index, 1);
        }
        this.setState({checkedBoxes:checkedBoxes});
    }

    handleDaysCheckbox = (e, s) => {
        const dayscheckedBoxes = [...this.state.dayscheckedBoxes];
        if(e.target.checked) {
            dayscheckedBoxes.push(s)
        } else {
            const index = dayscheckedBoxes.findIndex((ch) => ch.id === s);
            dayscheckedBoxes.splice(index, 1);
        }
        this.setState({dayscheckedBoxes:dayscheckedBoxes});
        console.log(dayscheckedBoxes)
    }

    postBulkBooking(details, courts,days, props) {
        if(details.customer_id === ''){
            alert("Enter Customer")
        }
        else{
          this.setState({loading:true})
          var date = moment(details.starting_date, ["DD-MM-YYYY", "DD/MM/YYYY","YYYY/MM/DD","YYYY-MM-DD"], true).format("YYYY-MM-DD")
          var ending_date = moment(details.ending_date, ["DD-MM-YYYY", "DD/MM/YYYY","YYYY/MM/DD","YYYY-MM-DD"], true).format("YYYY-MM-DD")
          this.setState({submit_pressed:true})
          if(this.state.details.venue === ''){
            var venue = this.state.venue_list[0].id
          }
          else{
            var venue = details.venue
          } 
            const url = `${getLocationOrigin()}/eagleeye/bulk_booking/`;
            const options = {...defaultOptions};
            options['method'] = 'post';
            options['headers'] = {'content-type': 'application/json'}
            options['body'] = JSON.stringify({
                                'customer_id': details.customer_id,
                                'venue': venue,
                                'courts':courts,
                                'days':days,
                                'start_time': details.starting_time,
                                'end_time': details.ending_time,
                                'date': date,
                                'ending_date':ending_date,
                                'reason':details.reason,
                                'discount_amount':details.discount_amount,
                                'total_amount':this.state.total_amount,
                                'net_amount':this.state.net_amount,
                                'advance_amount':this.state.advance_amount
                            });
            return fetch(url, options)
            .then(checkStatus)
            .then(parseJSON)
            .then((response) => {                  
                alert(response.message);
                this.setState({loading:false})
                // props.history.goBack();
                })
            .catch((error) => {
                console.log(error);
                alert(error.message);
                this.setState({loading:false})
            });
        }
      }

      check_availability(data, courts,days,props) {
        if(courts.length === 0){
          alert("select court")
        }
        else if(days.length === 0){
            alert("select day")
        }
        else if(data.starting_date === ''){
            alert("Enter Start Date")
        }
        else if(data.ending_date === ''){
            alert("Enter End Date")
        }
        else if(data.starting_time === ''){
            alert("Enter Start Time")
        }
        else if(data.ending_time === ''){
            alert("Enter End Time")
        }
        else if(data.reason === ''){
          alert("Enter Reason")
        }
      else{
        this.setState({loading:true})
        var date = moment(data.starting_date, ["DD-MM-YYYY", "DD/MM/YYYY","YYYY/MM/DD","YYYY-MM-DD"], true).format("YYYY-MM-DD")
        var ending_date = moment(data.ending_date, ["DD-MM-YYYY", "DD/MM/YYYY","YYYY/MM/DD","YYYY-MM-DD"], true).format("YYYY-MM-DD")
        const url = `${getLocationOrigin()}/court_booking/check_availability/`;
        const options = {...defaultOptions};
        if(this.state.details.venue === ''){
          var venue = this.state.venue_list[0].id
        }
        else{
          var venue = data.venue
        } 
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
        options['body'] = JSON.stringify({
                            'venue': venue,
                            'courts':courts,
                            'days':days,
                            'start_time': data.starting_time,
                            'end_time': data.ending_time,
                            'date': date,
                            'ending_date': ending_date,
                            'reason':data.reason
                          });
        console.log('Going to fetch');
        console.log(options['body'])
        return fetch(url, options)
          .then(checkStatus)
          .then(parseJSON)
          .then((response) => {  
            console.log('response')
            console.log(response)    
            if(response.available_slot.length > 0 || response.blocked_slot.length > 0){
              this.setState({dialog_open_court_list:true, available_court_list:response.available_slot, blocked_court_list:response.blocked_slot, total_slots:response.total_slots,no_of_available_slots:response.available_slot.length,no_of_blocked_slots:response.blocked_slot.length, total_price:response.total_price,advance_amount:response.total_price, net_amount:response.total_price});  
            } 
            else{
              alert("No Slot Matched")
            }  
            this.setState({loading:false})
              // alert(response.message);
              // props.history.goBack();
            })
          .catch((error) => {
            console.log(error);
            alert(error.message);
            this.setState({loading:false})
          });
        }
      }

    handleBooking(event){
      this.postBulkBooking(this.state.details, this.state.checkedBoxes, this.state.dayscheckedBoxes,this.props)
    }

    handleFormSubmit(event){
        event.preventDefault();
        this.check_availability(this.state.details, this.state.checkedBoxes, this.state.dayscheckedBoxes,this.props)
        // this.postBulkBooking(this.state.details, this.state.checkedBoxes, this.state.dayscheckedBoxes, this.props)
    }

    handleStartDate(date){
      var new_selected_one =  Object.assign({}, this.state.details);
      new_selected_one['starting_date'] = date
      this.setState({details:new_selected_one })
    }

    handleEndDate(date){
      var new_selected_one =  Object.assign({}, this.state.details);
      new_selected_one['ending_date'] = date
      this.setState({details:new_selected_one })
    }

    getPricing = () => {
      this.setState({dialog_open_court_list:false})
      if(this.state.available_court_list.length > 0){
      this.setState({show_booking_option:true})
      }
      else{
        alert("No Slots Available")
      }
    }

    handleDiscountApply = () => {
      console.log(this.state.details.discount_amount)
      console.log(this.state.total_price)
      if(this.state.details.discount_amount < this.state.total_price){
      var net_price = this.state.total_price - this.state.details.discount_amount
      }
      else{
        var net_price = 0
      }
      this.setState({net_amount:net_price})
      this.setState({advance_amount:net_price})
    }
  
    render() {
      console.log('render')
      console.log(this.state.game_list)
      console.log(this.state.venue_list)
      console.log(this.state.court_list)
      console.log(this.state.checkedBoxes)
      console.log(this.state.dayscheckedBoxes)
      const actions = [
        <FlatButton
          label="Cancel"
          primary={true}
          onClick={this.handleClose}
        />,
        <FlatButton
          label="Add"
          primary={true}
          onClick={this.handleCustomerSubmit}
        />,
      ];
      const dialog_actions = [
        <FlatButton
          label="Cancel"
          primary={true}
          onClick={this.handleClose}
        />,
        <FlatButton
          label="Continue"
          primary={true}
          onClick={this.getPricing}
        />,
      ];
      var days = [{"name":"Monday","id":0},{"name":"Tuesday","id":1},{"name":"Wednesday","id":2},{"name":"Thrusday","id":3},{"name":"Friday","id":4},{"name":"Saturday","id":5},{"name":"Sunday","id":6}]

      return(
        <div style={styles.container}>
          <div className="row col-md-9 table-bordered" style={styles.table}>
            <div style={styles.main_header} className="col-md-12">
              <h3 style={{textAlign:'center'}}>Bulk Blocking</h3>
            </div>
            {this.state.loading === true ?
              <div style={{height:500}}>
                <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}>loading...</div>
              </div>
            :
            <div>
            <form  className="validated-form form-horizontal" onSubmit={this.handleFormSubmit}>
            <div style={styles.items} className="col-md-12">
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Venue
              </div>
              <select name="venue" className="col-md-6" style={styles.item_body} value={this.state.details.venue}
                onChange={this.handleVenueChange}>
                {/* <option value>-------</option> */}
                {
                  this.state.venue_list.map((x, index) => (
                  <option key={x.id} value={x.id}>{x.name}</option>
                  ))
                }
              </select>
            </div>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Game Type
              </div>
              <select name="game_type" className="col-md-6" style={styles.item_body} value={this.state.details.game_type}
                onChange={this.handleGameChange}>
                {
                  this.state.game_list.map((x, index) => (
                  <option key={x.game_id} value={x.game_id}>{x.game_name}</option>
                  ))
                }
              </select>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Reason
              </div>
              <select name="reason" className="col-md-6" style={styles.item_body} value={this.state.value}
                onChange={this.handleChange}>
                {/* <option value>-------</option> */}
                <option key='3' value='3'>Customer</option>
                <option key='4' value='4'>Tournament</option>
                <option key='5' value='5'>Other</option>
              </select>
            </div>
            
            {this.state.court_list.length > 0 && 
            <div>
            <div style={styles.items} className="col-md-12">
                <div style={styles.court_list}>
                {
                  this.state.court_list.map((x, index) => (
                    <label>
                    <input type="checkbox"
                    checked={this.state.checkedBoxes.find((ch) => ch.id === x.id)}
                    onChange={(e) => this.handleCheckbox(e, x)}
                  />
                  <div key={x.id} value={x.id}>{x.name}</div>
                  </label>
                  ))
                }
                </div>
            </div>

            <div style={{padding: '1%', display:'flex', flexDirection: 'row'}}>
            <div style={{display:'flex', flexDirection: 'row'}} className="col-md-12">
              <div style={{fontSize: '100%',fontWeight: 600,paddingLeft: '10%'}} className="col-md-6">
                Start Date
              </div>
              <DatePicker selected={this.state.details.starting_date} onChange={this.handleStartDate}/>
            </div>

            <div style={{display:'flex', flexDirection: 'row'}} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                To
              </div>
              <DatePicker selected={this.state.details.ending_date} onChange={this.handleEndDate}/>
            </div>
            </div>

            <div style={styles.items} className="col-md-12">
            <div style={styles.court_list}>
                {
                  days.map((x, index) => (
                    <label>
                    <input type="checkbox"
                    checked={this.state.dayscheckedBoxes.find((ch) => ch.id === index)}
                    onChange={(e) => this.handleDaysCheckbox(e, index)}
                  />
                  <div style={{paddingLeft: '3%', paddingRight:'3%',fontSize:12}} key={x.id} value={index}>{x.name}</div>
                  </label>
                  ))
                }
            </div>
            </div>
        
            <div style={{padding: '1%', display:'flex', flexDirection: 'row'}}>
            <div style={{display:'flex', flexDirection: 'row'}} className="col-md-12">
              <div style={{fontSize: '100%',fontWeight: 600,paddingLeft: '10%'}} className="col-md-6">
                Start Time(HH:MM:SS)
              </div>
              <TimeField value={this.state.details.starting_time} showSeconds style={styles.input} onChange={this.onStartTimeChange} />
            </div>
            <div style={{display:'flex', flexDirection: 'row'}} className="col-md-12">
              <div style={{fontSize: '100%',fontWeight: 600,paddingLeft: '10%'}} className="col-md-6">
               To
              </div>
              <TimeField value={this.state.details.ending_time} showSeconds style={styles.input} onChange={this.onTimeChange} />
            </div>
            </div>

            <div style={{display:'flex', flexDirection: 'row',marginTop:10}} className="col-md-12">
              <div style={{fontSize:'16', color:'red'}}>* for 23:00:00 slot enter end time as 23:59:00</div>
            </div>

                
            <div style={styles.button_submit} className="col-md-12">
              <input className="btn btn-lg" type="submit" value="Check Availability & Get Pricing" style={{backgroundColor:'#302C35',
                color:'#ffffff'}}/>
                <Dialog
                    actions={dialog_actions}
                    modal={false}
                    open={this.state.dialog_open_court_list}
                    onRequestClose={this.handleClose}
                    scroll={scroll}
                    dividers={scroll === 'paper'}
                  >
              <div>
                {this.state.blocked_court_list.length > 0 &&
                <div style={styles.main_header} className="col-md-12">
                  <h4 style={{textAlign:'center'}}>Following Slots are not available, press Continue to book the available slots or cancel.</h4>
                </div>
                }
                <div className="col-md-12" style={{flexDirection:'row',textAlign:'center'}}>
                <div className="col-md-4">
                    Total Slots
                  </div>
                  <div className="col-md-4">
                    Available Slots
                  </div>
                  <div className="col-md-4">
                    Unavailable Slots
                  </div>
                </div>
                <div className="col-md-12" style={{flexDirection:'row',textAlign:'center'}}>
                <div className="col-md-4">
                    {this.state.total_slots}
                  </div>
                  <div className="col-md-4">
                    {this.state.no_of_available_slots}
                  </div>
                  <div className="col-md-4">
                    {this.state.no_of_blocked_slots}
                  </div>
                </div>
                {this.state.blocked_court_list.length > 0 &&
                <div className="col-md-12" style={{flexDirection:'row',textAlign:'center', marginTop:10}}>
                  <div className="col-md-4">
                    Date
                  </div>
                  <div className="col-md-4">
                    Court 
                  </div>
                  <div className="col-md-4">
                    Time
                  </div>
                  </div>
                }
                {this.state.blocked_court_list.length > 0 ?
                <div>
                {this.state.blocked_court_list.map((list,index)=>
                <div className="col-md-12" style={{flexDirection:'row',textAlign:'center'}}>
                  <div className="col-md-4">
                    {list.date}
                  </div>
                  <div className="col-md-4">
                    {list.court.name}
                  </div>
                  <div className="col-md-4">
                    {list.start_time}
                  </div>
                  </div>
                  )}
                  </div>
                  :
                  <div className="col-md-12" style={{flexDirection:'row',textAlign:'center', marginTop:20}}>
                    <div>All slots Available!!</div>
                  </div>
                }
                </div>
            </Dialog>
            </div>
            </div>
            }
          </form>

          {this.state.show_booking_option &&
            <div style={styles.items} className="col-md-12">
              <div style={{marginTop:20}}>
                        <div style={{display:'flex', flexDirection: 'row'}} className="col-md-12">
                        <div style={{fontSize: '100%',fontWeight: 600,paddingLeft: '10%'}} className="col-md-6">
                        Customer
                        </div>
                        <div className="col-md-6 input-group">
                            <input type="text" name="mobile_no" className="form-control"
                            placeholder="Search for.. " value={this.state.details.mobile_no} onChange={this.handleChange}/>
                            <span className="input-group-btn">
                            <button className="btn btn-default glyphicon glyphicon-search"
                            type="button" onClick={this.searchCustomer}></button>
                            </span>
                        </div>
                        </div>
                        {this.state.search?
                        <div className="col-md-12 btn-group">
                            {this.state.customer_search_list.length?this.state.customer_search_list.map((x) =>(<button key={x.mobile_no+x.name} className="btn btn-default"
                        style={{padding:'1%'}} onClick={() => this.setSearch(x.name,x.id, x.mobile_no)}>{x.name}:{x.mobile_no}</button>))
                        :<div className="alert alert-danger" style={{justifyContent: 'space-between', display: 'flex'}}>
                        <div className="alert alert-danger">Search customer not found</div>
                        <div>
                        <RaisedButton
                        onClick={this.handleOpen}
                        label="Add"
                        style={{float:'right'}}
                        secondary={true}
                        />
                        <Dialog
                        actions={actions}
                        modal={false}
                        open={this.state.dialog_open_cust}
                        onRequestClose={this.handleClose}
                        >
                        <div>
                            <div style={styles.main_header} className="col-md-12">
                            <h3 style={{textAlign:'center'}}>Add New Customer</h3>
                            </div>
                            <div style={styles.items} className="col-md-12">
                            <div style={styles.item_header} className="col-md-6">
                                Name
                            </div>
                            <input type="text" style={styles.input} name="cust_name" className="required"
                                value={this.state.value} onChange={this.handleChange}/>
                            </div>

                            <div style={styles.items} className="col-md-12">
                            <div style={styles.item_header} className="col-md-6">
                                Mobile No
                            </div>
                            <input type="number" style={styles.input} name="cust_mobile_no" className="required"
                                value={this.state.details.mobile_no} onChange={this.handleChange}/>
                            </div>
                        </div>
                        </Dialog>
                    </div>
                    </div>
                }</div>:''}
            </div>
            <div style={{display:'flex', flexDirection: 'row',marginTop:10}} className="col-md-12">
              <div style={{fontSize: '100%',fontWeight: 600,paddingLeft: '10%'}} className="col-md-6">
              Amount to pay
              </div>
              <div className="col-md-6">
                {this.state.total_price}
              </div>
            </div>

            <div style={{display:'flex', flexDirection: 'row',marginTop:10}} className="col-md-12">
              <div style={{fontSize: '100%',fontWeight: 600,paddingLeft: '10%'}} className="col-md-6">
              Discount Amount
              </div>
              <div className="col-md-3">
                  <input type="number" style={styles.input} name="discount_amount" className="required"
                    value={this.state.details.discount_amount} onChange={this.handleChange}/>
              </div>
              <div className="col-md-3">
                <button
                  type="button"
                  onClick={this.handleDiscountApply}>
                    Apply
                </button>
              </div>
            </div>
              
              
            <div style={{display:'flex', flexDirection: 'row', marginTop:10}} className="col-md-12">
                <div style={{fontSize: '100%',fontWeight: 600,paddingLeft: '10%'}} className="col-md-6">
                  Net Amount
                </div>
              <div className="col-md-6">
              {this.state.net_amount}
              </div>
            </div>

            <div style={{display:'flex', flexDirection: 'row', marginTop:10}} className="col-md-12">
                <div style={{fontSize: '100%',fontWeight: 600,paddingLeft: '10%'}} className="col-md-6">
                  Advance Amount
                </div>
              <div className="col-md-6">
              <input type="number" style={styles.input} className="required" name="advance_amount" value={this.state.advance_amount}
                    onChange={(event)=>{this.setState({advance_amount:event.target.value})}}/>
              </div>
            </div>

            {/* <div style={{display:'flex', flexDirection: 'row', marginTop:10}} className="col-md-12">
                <div style={{fontSize: '100%',fontWeight: 600,paddingLeft: '10%'}} className="col-md-6">
                  Advance
                </div>
            <div className="col-md-6">
              <input type="number" style={styles.input} name="advance_amount" className="required"
                      value={this.state.details.advance_amount} onChange={this.handleChange}/>
            </div>
            </div> */}

            <div style={styles.button_submit} className="col-md-12">
                 <button
                 className="btn btn-lg"
                  type="button"
                  value="Submit" 
                  style={{backgroundColor:'#302C35',color:'#ffffff',width:130,height:40}}
                  onClick={this.handleBooking} >
                  Submit
                  </button>
            </div>

          </div>
        }
        </div>
        }
          </div>
        </div>
      );
    }
  }
  
  export default AddBulkBooking;
  


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/addBulBooking/index.js